(ns common.cookies
  (:require [common.db.config :refer [get-config]]
            [goog.net.Cookies]))

(defonce ^:dynamic *cookies* (.getInstance goog.net.Cookies))

(defn set-cookie!
  [k content {:keys [domain path max-age raw?] :as opts}]
  (let [k (name k)
        content (if raw?
                  (str content)
                  (pr-str content))
        set-opts (goog.net.Cookies.SetOptions.)
        same-site (:cookieSameSite (get-config) (.-STRICT goog.net.Cookies.SameSite))]
    (js/console.log "cookie:" k same-site domain)
    (set! (.-maxAge set-opts) (or max-age -1))
    (set! (.-domain set-opts) domain)
    (set! (.-path set-opts) path)
    (set! (.-sameSite set-opts) same-site)
    (set! (.-secure set-opts) true)
    (if opts
      (.set *cookies* k content set-opts)
      (.set *cookies* k content))))

(defn get-cookie [k]
  (let [cookie-value (.get *cookies* (name k))]
    (try
      (js->clj (js/JSON.parse cookie-value) :keywordize-keys true)
      (catch js/Object _
        cookie-value))))

(defn remove!
  ([k]
   (.remove *cookies* (name k)))
  ([k path domain]
   (.remove *cookies* (name k) path domain)))
